"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSymphonyLogo = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SYMPHONY-LOGO", width: "1em", height: "1em", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { cx: 7, cy: 7, r: 7, fill: "#008EFF" }),
    React.createElement("path", { d: "M4.773 8.932c0 .208.12.4.315.504L7 10.456l1.912-1.02a.575.575 0 0 0 .315-.504V7.878L3.5 6.422V3.81c0-.383.215-.797.676-.987.492-.203 1.435-.49 2.824-.49 1.389 0 2.332.287 2.824.49.46.19.676.604.676.987v1.468l-1.273-.324V3.856C8.854 3.712 8.113 3.498 7 3.498c-1.113 0-1.854.214-2.227.358v1.68L10.5 7v1.932c0 .622-.36 1.197-.947 1.51L7.48 11.548a1.031 1.031 0 0 1-.962 0l-2.072-1.106c-.586-.313-.947-.888-.947-1.51V7.866l1.273.3v.766Z", fill: "#fff" }))); };
exports.default = SvgSymphonyLogo;
